/** @jsx tsx */
import { tsx } from "@dojo/framework/core/vdom";
import { WidgetBase } from "@dojo/framework/core/WidgetBase";
import { CanvasCreateShape, ICreateShapeRenderProps } from "./components/CanvasCreateShape";
import { CanvasPage, IPageRenderProps } from "./components/CanvasPage";
import { GuidesOverlay, IGuidesOverlayProps } from "./components/GuidesOverlay";
import { ISelectionOverlay, SelectionOverlay } from "./components/SelectionOverlay";

/** Canvas state connected editor render props */
export interface ICanvasStateConnectedEditorRenderProps {
    /** Page render props */
    pageProps: IPageRenderProps;

    /** Create shape container render props */
    createShapeProps: ICreateShapeRenderProps;

    /** Selection overlay props */
    selectionOverlayProps: ISelectionOverlay;

    /** Guides overlay props */
    guidesOverlayProps: IGuidesOverlayProps;
}

/**
 * Canvas state connected editor component.
 * Provides base component for rendering canvas page, canvas create shape component, selection overlay, and guides
 * overlay.
 *
 * This component would be the only component connected to redux state. No other component in its hierarchy will connect
 * to redux state. This is essential for the desired real time synchronized reflection of changes across different
 * layers
 */
export class CanvasStateConnectedEditor extends WidgetBase<ICanvasStateConnectedEditorRenderProps> {
	/**
     * Override WidgetBase#render to produce a virtual DOM tree.
     * @returns {HNode} Each time render() executes, it should build the entire virtual DOM tree.
     */
	protected render() {
		return (
			<div classes="c8_canvas_root">
				<div classes={["c8_canvas_root_inner", "csi-canvas-drag-over"]}>
					<CanvasPage {...this.properties.pageProps} />
					<SelectionOverlay {...this.properties.selectionOverlayProps} />
					<GuidesOverlay {...this.properties.guidesOverlayProps} />
				</div>
				<CanvasCreateShape {...this.properties.createShapeProps} />
			</div>
		);
	}
}

export default CanvasStateConnectedEditor;
